import { FC } from 'react'
import iconModule from '@/assets/img/icons/dtp2.png'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 25, height = 25 }) => {
  return (
    <img
      src={iconModule}
      alt='DTP'
      width={width}
      height={height}
    />
  )
}

export default Icon
